import store from "@/store";

/**
 * Every spelling the 213 `showToast` call sites use, plus the raw colour names
 * that would otherwise slip past the theme, mapped to one of four states.
 * Anything not listed here is treated as `info` — never as a success.
 */
const SNACK_COLORS = {
    s: "success",
    success: "success",
    green: "success",
    e: "error",
    error: "error",
    red: "error",
    danger: "error",
    w: "warning",
    warning: "warning",
    warn: "warning",
    amber: "warning",
    yellow: "warning",
    i: "info",
    info: "info",
};

export default {
    namespaced: true,
    state: {
        show: false,
        config: {
            color: "success",
            message: "",
            top: true,
            bottom: false,
            left: false,
            right: true,
            timeout: 3500,
            multi_line: false,
            // Optional { text, to } -- a button on the toast that routes
            // somewhere (e.g. "Open Reports" after queuing a report).
            action: null,
        },
    },
    mutations: {
        SHOW_SNACK(state, data) {
            state.config.message = data.message;
            state.config.color = data.color || "success";

            state.config.top = !store.state.isMobile;
            state.config.bottom = store.state.isMobile;
            state.config.right = !store.state.isMobile;

            // Normalise to the four theme colours, which resolve to the
            // AA-passing tokens in plugins/vuetify.js (success #15803d,
            // error #b91c1c, warning #b45309).
            //
            // The old version only recognised the single letters "s"/"e"/"w"
            // and passed anything else straight to Vuetify. That made two
            // silent failure modes: a raw colour name ("red", "green") bypassed
            // the palette and rendered Material's #F44336/#4CAF50, and any
            // unrecognised or blank value fell through `data.color || "success"`
            // and painted an ERROR message GREEN. An unknown state is not a
            // success — it now falls back to `info`.
            state.config.color = SNACK_COLORS[
                String(data.color || "").trim().toLowerCase()
            ] || "info";
            state.config.timeout = data.timeout || 3000;
            state.config.action =
                data.action && data.action.to ? data.action : null;
            // state.config.multi_line = data.message.length > 30
            state.show = true;
        },
        CLOSE_SNACK(state) {
            state.show = false;
            // state.config.color = "";
            state.config.message = "";
            state.config.action = null;
        },
    },
    actions: {
        showToast({ commit }, tabJson) {
            commit("SHOW_SNACK", tabJson);
        },
        hideToast({ commit }) {
            commit("CLOSE_SNACK");
        },
    },
    modules: {},
};